import Icon from '../components/Icon.vue'

Icon.register({
  unlink: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M304.1 405.9C308.8 410.6 308.8 418.2 304.1 422.9L259.4 467.6C200.1 526.8 103.7 526.8 44.4 467.6-14.8 408.3-14.8 311.9 44.4 252.6L89.1 207.9C93.8 203.2 101.4 203.2 106.1 207.9L145.7 247.5C150.4 252.2 150.4 259.8 145.7 264.5L101 309.2C72.9 337.2 72.9 382.9 101 411 129.1 439.1 174.8 439.1 202.8 411L247.5 366.3C252.2 361.6 259.8 361.6 264.5 366.3L304.1 405.9zM247.5 145.7C252.2 150.4 259.8 150.4 264.5 145.7L309.2 101C337.2 72.9 382.9 72.9 411 101 439.1 129.1 439.1 174.8 411 202.8L366.3 247.5C361.6 252.2 361.6 259.8 366.3 264.5L405.9 304.1C410.6 308.8 418.2 308.8 422.9 304.1L467.6 259.4C526.8 200.1 526.8 103.7 467.6 44.4 408.3-14.8 311.9-14.8 252.6 44.4L207.9 89.1C203.2 93.8 203.2 101.4 207.9 106.1L247.5 145.7zM482.3 505L505 482.3C514.3 473 514.3 457.8 505 448.4L63.6 7C54.2-2.3 39-2.3 29.7 7L7 29.7C-2.3 39-2.3 54.2 7 63.6L448.4 505C457.8 514.3 473 514.3 482.3 505z'
      }
    ]
  }
})
